import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import { GACodes } from '../../types';

export const trackFollowActionLocation = (label: string) => {
    trackAnalyticsEvent({
        category: GACodes.GA_CATEGORY_LISTING,
        action: 'FollowActionLocation',
        label: label,
    });
};
